<template>
  <div class="navbar-wrapper fixed-top">
    <div class="mobile-topbar d-lg-none">
      <a class="mobile-topbar__logo" href="/" aria-label="Ir al inicio">
        <img
          src="@/assets/images/logo.png"
          :alt="`${storeName} logo`"
          class="mobile-topbar__logo-img"
          width="120"
          height="36"
        />
      </a>
      <button
        type="button"
        class="mobile-topbar__action"
        @click="toggleMiniCart"
        aria-label="Abrir carrito"
      >
        <i class="fas fa-shopping-bag" aria-hidden="true"></i>
        <span v-if="cartCount" class="mobile-topbar__badge">{{ cartCount }}</span>
      </button>
    </div>

    <!-- Fila principal: logo izquierda | búsqueda centro | cuenta + carrito derecha -->
    <nav class="navbar navbar-main-bar pb-0">
      <div class="container py-2 px-lg-3 px-0">
        <div class="navbar-main-row d-flex align-items-center w-100 gap-2 gap-lg-3">
          <div class="navbar-main-row__start d-flex align-items-center gap-1 flex-shrink-0">
           

            <a class="navbar-brand flex-shrink-0 me-0" href="/">
              <div class="brand-container">
                <img
                  src="@/assets/images/logo.png"
                  :alt="`${storeName} logo`"
                  class="logo-img img-fluid"
                  width="180"
                  height="54"
                />
              </div>
            </a>
          </div>

          <form
            class="navbar-search-pill d-none d-lg-flex flex-grow-1 mx-lg-3"
            role="search"
            @submit.prevent="handleNavbarSearch"
          >
            <label class="visually-hidden" for="navbar-search-input">Buscar productos</label>
            <div class="navbar-search-inner w-100">
              <input
                id="navbar-search-input"
                v-model="navbarSearchQuery"
                type="search"
                class="navbar-search-field"
                placeholder="Buscar"
                autocomplete="off"
                @input="handleNavbarSearchInput"
                @focus="handleNavbarSearchFocus"
                @blur="handleNavbarSearchBlur"
              />
              <button
                v-if="navbarSearchQuery"
                type="button"
                class="navbar-search-clear"
                aria-label="Limpiar búsqueda"
                @mousedown.prevent
                @click="clearNavbarSearch"
              >
                <i class="fas fa-times"></i>
              </button>
              <button type="submit" class="navbar-search-submit" aria-label="Buscar">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="navbar-svg-icon">
                  <path d="M10.77 18.3C9.2807 18.3 7.82485 17.8584 6.58655 17.031C5.34825 16.2036 4.38311 15.0275 3.81318 13.6516C3.24325 12.2757 3.09413 10.7616 3.38468 9.30096C3.67523 7.84029 4.39239 6.49857 5.44548 5.44548C6.49857 4.39239 7.84029 3.67523 9.30096 3.38468C10.7616 3.09413 12.2757 3.24325 13.6516 3.81318C15.0275 4.38311 16.2036 5.34825 17.031 6.58655C17.8584 7.82485 18.3 9.2807 18.3 10.77C18.3 11.7588 18.1052 12.738 17.7268 13.6516C17.3484 14.5652 16.7937 15.3953 16.0945 16.0945C15.3953 16.7937 14.5652 17.3484 13.6516 17.7268C12.738 18.1052 11.7588 18.3 10.77 18.3ZM10.77 4.74999C9.58331 4.74999 8.42327 5.10189 7.43657 5.76118C6.44988 6.42046 5.68084 7.35754 5.22672 8.45389C4.77259 9.55025 4.65377 10.7566 4.88528 11.9205C5.11679 13.0844 5.68824 14.1535 6.52735 14.9926C7.36647 15.8317 8.43556 16.4032 9.59945 16.6347C10.7633 16.8662 11.9697 16.7474 13.0661 16.2933C14.1624 15.8391 15.0995 15.0701 15.7588 14.0834C16.4181 13.0967 16.77 11.9367 16.77 10.75C16.77 9.15869 16.1379 7.63257 15.0126 6.50735C13.8874 5.38213 12.3613 4.74999 10.77 4.74999Z" fill="currentColor"/>
                  <path d="M20 20.75C19.9015 20.7504 19.8038 20.7312 19.7128 20.6934C19.6218 20.6557 19.5392 20.6001 19.47 20.53L15.34 16.4C15.2075 16.2578 15.1354 16.0697 15.1388 15.8754C15.1422 15.6811 15.221 15.4958 15.3584 15.3583C15.4958 15.2209 15.6812 15.1422 15.8755 15.1388C16.0698 15.1354 16.2578 15.2075 16.4 15.34L20.53 19.47C20.6704 19.6106 20.7493 19.8012 20.7493 20C20.7493 20.1987 20.6704 20.3893 20.53 20.53C20.4608 20.6001 20.3782 20.6557 20.2872 20.6934C20.1962 20.7312 20.0985 20.7504 20 20.75Z" fill="currentColor"/>
                </svg>
              </button>
              <div
                v-if="navbarShowSuggestions"
                class="navbar-search-suggestions"
                @mousedown.prevent
              >
                <div v-if="navbarIsSearching" class="navbar-suggest-loading">
                  <div class="navbar-suggest-skeleton" v-for="n in 4" :key="`nav-skel-${n}`">
                    <div class="navbar-suggest-skeleton-img"></div>
                    <div class="navbar-suggest-skeleton-lines">
                      <div class="navbar-suggest-skeleton-line"></div>
                      <div class="navbar-suggest-skeleton-line short"></div>
                    </div>
                  </div>
                </div>
                <template v-else>
                  <div v-if="navbarSearchResults.length" class="navbar-suggest-list">
                    <button
                      v-for="product in navbarSearchResults"
                      :key="`nav-suggest-${product.id}`"
                      type="button"
                      class="navbar-suggest-item"
                      @click="handleNavbarSuggestionClick(product)"
                    >
                      <span class="navbar-suggest-thumb">
                        <img
                          v-if="product.image"
                          :src="product.image"
                          :alt="product.name"
                          loading="lazy"
                        />
                        <span v-else class="navbar-suggest-thumb-placeholder">
                          <i class="fas fa-box"></i>
                        </span>
                      </span>
                      <span class="navbar-suggest-info">
                        <span class="navbar-suggest-name">{{ product.name }}</span>
                        <span v-if="product.brand" class="navbar-suggest-brand">{{ product.brand }}</span>
                      </span>
                      <span class="navbar-suggest-price">
                        {{ formatPrice(product.final_price || product.price, product.currency) }}
                      </span>
                    </button>
                    <button
                      type="button"
                      class="navbar-suggest-see-all"
                      @click="handleNavbarSearch"
                    >
                      Ver todos los resultados
                    </button>
                  </div>
                  <div v-else class="navbar-suggest-empty">
                    <i class="fas fa-search"></i>
                    <span>No encontramos productos para "{{ navbarSearchQuery.trim() }}"</span>
                  </div>
                </template>
              </div>
            </div>
          </form>

          <div class="nav-actions d-flex align-items-center flex-shrink-0 ms-auto gap-2 gap-lg-3">
            <a
              @click.prevent="handleUserAccount"
              href="#"
              class="user-account-icon d-none d-md-flex text-decoration-none text-white align-items-center justify-content-center"
              aria-label="Mi cuenta"
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="navbar-svg-icon">
                <path d="M12 12.25C11.2583 12.25 10.5333 12.0301 9.91661 11.618C9.29993 11.206 8.81928 10.6203 8.53545 9.93506C8.25163 9.24984 8.17736 8.49584 8.32206 7.76841C8.46675 7.04098 8.8239 6.3728 9.34835 5.84835C9.8728 5.3239 10.541 4.96675 11.2684 4.82206C11.9958 4.67736 12.7498 4.75162 13.4351 5.03545C14.1203 5.31928 14.706 5.79993 15.118 6.41661C15.5301 7.0333 15.75 7.75832 15.75 8.5C15.75 9.49456 15.3549 10.4484 14.6517 11.1517C13.9484 11.8549 12.9946 12.25 12 12.25ZM12 6.25C11.555 6.25 11.12 6.38196 10.75 6.62919C10.38 6.87643 10.0916 7.22783 9.92127 7.63896C9.75098 8.0501 9.70642 8.5025 9.79323 8.93895C9.88005 9.37541 10.0943 9.77632 10.409 10.091C10.7237 10.4057 11.1246 10.62 11.561 10.7068C11.9975 10.7936 12.4499 10.749 12.861 10.5787C13.2722 10.4084 13.6236 10.12 13.8708 9.75003C14.118 9.38002 14.25 8.94501 14.25 8.5C14.25 7.90326 14.0129 7.33097 13.591 6.90901C13.169 6.48705 12.5967 6.25 12 6.25Z" fill="currentColor"/>
                <path d="M19 19.25C18.8019 19.2474 18.6126 19.1676 18.4725 19.0275C18.3324 18.8874 18.2526 18.6981 18.25 18.5C18.25 16.55 17.19 15.25 12 15.25C6.81 15.25 5.75 16.55 5.75 18.5C5.75 18.6989 5.67098 18.8897 5.53033 19.0303C5.38968 19.171 5.19891 19.25 5 19.25C4.80109 19.25 4.61032 19.171 4.46967 19.0303C4.32902 18.8897 4.25 18.6989 4.25 18.5C4.25 13.75 9.68 13.75 12 13.75C14.32 13.75 19.75 13.75 19.75 18.5C19.7474 18.6981 19.6676 18.8874 19.5275 19.0275C19.3874 19.1676 19.1981 19.2474 19 19.25Z" fill="currentColor"/>
              </svg>
            </a>

            <button
              type="button"
              class="desktop-search-btn d-lg-none border-0 bg-transparent p-1"
              @click="toggleSearchDrawer"
              aria-label="Buscar productos"
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="navbar-svg-icon">
                <path d="M10.77 18.3C9.2807 18.3 7.82485 17.8584 6.58655 17.031C5.34825 16.2036 4.38311 15.0275 3.81318 13.6516C3.24325 12.2757 3.09413 10.7616 3.38468 9.30096C3.67523 7.84029 4.39239 6.49857 5.44548 5.44548C6.49857 4.39239 7.84029 3.67523 9.30096 3.38468C10.7616 3.09413 12.2757 3.24325 13.6516 3.81318C15.0275 4.38311 16.2036 5.34825 17.031 6.58655C17.8584 7.82485 18.3 9.2807 18.3 10.77C18.3 11.7588 18.1052 12.738 17.7268 13.6516C17.3484 14.5652 16.7937 15.3953 16.0945 16.0945C15.3953 16.7937 14.5652 17.3484 13.6516 17.7268C12.738 18.1052 11.7588 18.3 10.77 18.3ZM10.77 4.74999C9.58331 4.74999 8.42327 5.10189 7.43657 5.76118C6.44988 6.42046 5.68084 7.35754 5.22672 8.45389C4.77259 9.55025 4.65377 10.7566 4.88528 11.9205C5.11679 13.0844 5.68824 14.1535 6.52735 14.9926C7.36647 15.8317 8.43556 16.4032 9.59945 16.6347C10.7633 16.8662 11.9697 16.7474 13.0661 16.2933C14.1624 15.8391 15.0995 15.0701 15.7588 14.0834C16.4181 13.0967 16.77 11.9367 16.77 10.75C16.77 9.15869 16.1379 7.63257 15.0126 6.50735C13.8874 5.38213 12.3613 4.74999 10.77 4.74999Z" fill="currentColor"/>
                <path d="M20 20.75C19.9015 20.7504 19.8038 20.7312 19.7128 20.6934C19.6218 20.6557 19.5392 20.6001 19.47 20.53L15.34 16.4C15.2075 16.2578 15.1354 16.0697 15.1388 15.8754C15.1422 15.6811 15.221 15.4958 15.3584 15.3583C15.4958 15.2209 15.6812 15.1422 15.8755 15.1388C16.0698 15.1354 16.2578 15.2075 16.4 15.34L20.53 19.47C20.6704 19.6106 20.7493 19.8012 20.7493 20C20.7493 20.1987 20.6704 20.3893 20.53 20.53C20.4608 20.6001 20.3782 20.6557 20.2872 20.6934C20.1962 20.7312 20.0985 20.7504 20 20.75Z" fill="currentColor"/>
              </svg>
            </button>

            <button
              type="button"
              class="cart-block border-0 bg-transparent d-flex align-items-center gap-2 text-start text-white"
              @click="toggleMiniCart"
              aria-label="Ver carrito"
            >
              <span class="cart-icon-wrap position-relative d-inline-flex">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="navbar-svg-icon">
                  <path d="M19.5 8.25H16.5V7.75C16.5 6.55653 16.0259 5.41193 15.182 4.56802C14.3381 3.72411 13.1935 3.25 12 3.25C10.8065 3.25 9.66193 3.72411 8.81802 4.56802C7.97411 5.41193 7.5 6.55653 7.5 7.75V8.25H4.5C4.16848 8.25 3.85054 8.3817 3.61612 8.61612C3.3817 8.85054 3.25 9.16848 3.25 9.5V18C3.25 18.7293 3.53973 19.4288 4.05546 19.9445C4.57118 20.4603 5.27065 20.75 6 20.75H18C18.7293 20.75 19.4288 20.4603 19.9445 19.9445C20.4603 19.4288 20.75 18.7293 20.75 18V9.5C20.75 9.16848 20.6183 8.85054 20.3839 8.61612C20.1495 8.3817 19.8315 8.25 19.5 8.25ZM9 7.75C9 6.95435 9.31607 6.19129 9.87868 5.62868C10.4413 5.06607 11.2044 4.75 12 4.75C12.7956 4.75 13.5587 5.06607 14.1213 5.62868C14.6839 6.19129 15 6.95435 15 7.75V8.25H9V7.75ZM19.25 18C19.25 18.3315 19.1183 18.6495 18.8839 18.8839C18.6495 19.1183 18.3315 19.25 18 19.25H6C5.66848 19.25 5.35054 19.1183 5.11612 18.8839C4.8817 18.6495 4.75 18.3315 4.75 18V9.75H7.5V12C7.5 12.1989 7.57902 12.3897 7.71967 12.5303C7.86032 12.671 8.05109 12.75 8.25 12.75C8.44891 12.75 8.63968 12.671 8.78033 12.5303C8.92098 12.3897 9 12.1989 9 12V9.75H15V12C15 12.1989 15.079 12.3897 15.2197 12.5303C15.3603 12.671 15.5511 12.75 15.75 12.75C15.9489 12.75 16.1397 12.671 16.2803 12.5303C16.421 12.3897 16.5 12.1989 16.5 12V9.75H19.25V18Z" fill="currentColor"/>
                </svg>
                <span class="badge badge-pill cart-count">{{ cartCount }}</span>
              </span>
              <span class="cart-labels d-none d-sm-flex flex-column lh-sm">
                <span class="cart-label-top small text-white-50">Tu carrito</span>
                <span class="cart-label-price fw-semibold">{{ formattedCartTotal }}</span>
              </span>
            </button>
            <button
              class="mobile-menu-toggle mobile-icon-btn d-lg-none border-0 flex-shrink-0 ms-2"
              type="button"
              @click="toggleMobileMenu"
              :aria-expanded="isMobileMenuOpen"
              aria-label="Abrir menú"
            >
              <i class="fas text-white" :class="isMobileMenuOpen ? 'fa-times' : 'fa-bars'"></i>
            </button>
          </div>
        </div>
      </div>
    </nav>


    <!-- Fila de menú: categorías desde API + enlaces fijos (desktop) -->
    <div class="navbar-nav-row d-none d-lg-block">
      <div class="container">
        <div class="nav-row-menu-outer py-2">
          <div class="nav-row-menu-cluster d-flex flex-nowrap align-items-center min-w-0">
            <div class="nav-row-menu-overflow min-w-0">
              <ul class="nav-row-menu list-unstyled d-flex flex-nowrap align-items-center mb-0">
          <li class="nav-item dropdown nav-row-item">
            <a
              class="nav-row-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              data-bs-auto-close="true"
              :data-bs-popper-config="navRowDropdownPopperFixed"
              aria-expanded="false"
            >Inicio</a>
            <ul class="dropdown-menu dropdown-menu-nav shadow-sm border-0">
              <li><router-link class="dropdown-item" to="/">Inicio</router-link></li>
              <li><router-link class="dropdown-item" to="/productos">Catálogo</router-link></li>
            </ul>
          </li>
          <li
            v-for="category in parentCategoriesNavOrder"
            :key="'nav-' + category.id"
            class="nav-item nav-row-item"
            :class="{ dropdown: hasSubcategories(category.id) }"
          >
            <template v-if="hasSubcategories(category.id)">
              <router-link
                class="nav-row-link dropdown-toggle"
                :to="categoryProductsRoute(category.name)"
              >{{ category.name }}</router-link>
              <ul class="dropdown-menu dropdown-menu-nav shadow-sm border-0">
                <li
                  v-for="sub in getDirectSubcategories(category.id)"
                  :key="sub.id"
                >
                  <router-link
                    class="dropdown-item"
                    :to="categoryProductsRoute(sub.name)"
                  >{{ sub.name }}</router-link>
                </li>
                <li><hr class="dropdown-divider my-1"></li>
                <li>
                  <router-link
                    class="dropdown-item fw-semibold"
                    :to="categoryProductsRoute(category.name)"
                  >Ver todo · {{ category.name }}</router-link>
                </li>
              </ul>
            </template>
            <router-link
              v-else
              class="nav-row-link nav-row-link-plain"
              :to="categoryProductsRoute(category.name)"
            >{{ category.name }}</router-link>
          </li>
          <li class="nav-item dropdown nav-row-item">
            <a
              class="nav-row-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              :data-bs-popper-config="navRowDropdownPopperFixed"
              aria-expanded="false"
            >Ayuda</a>
            <ul class="dropdown-menu dropdown-menu-nav shadow-sm border-0">
              <li><router-link class="dropdown-item" to="/nosotros">Nosotros</router-link></li>
              <li><router-link class="dropdown-item" to="/blog">Blog</router-link></li>
              <li><router-link class="dropdown-item" to="/contacto">Contacto</router-link></li>
              <li><router-link class="dropdown-item" to="/productos?sale=true">Ofertas</router-link></li>
            </ul>
          </li>
              </ul>
            </div>
            <div class="nav-row-menu-tail nav-item nav-row-item d-flex align-items-center flex-shrink-0">
              <router-link class="nav-row-link nav-row-link-plain" to="/productos">Todos</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="promo-banner promo-banner--with-marquee">
      <div class="promo-banner__marquee">
        <MarqueeBanner dense :items="marqueeItems" speed="32s" />
      </div>
    </div>

    <!-- Desktop Offcanvas Menu (nuevo) -->
    <div class="desktop-offcanvas-menu" :class="{ show: isDesktopMenuOpen }">
      <div class="offcanvas-header">
        <div class="d-flex align-items-center">
          <h5 class="offcanvas-title fs-5">Categorías</h5>
        </div>
        <button type="button" class="btn-close" @click="closeDesktopMenu" aria-label="Close"></button>
      </div>

      <div class="offcanvas-body">
        <!-- Menu Accordion -->
        <div class="desktop-menu accordion" id="desktopMenuAccordion">
          <!-- Skeleton Loaders -->
          <div v-if="isLoadingCategories" class="desktop-skeleton-menu">
            <div v-for="index in 5" :key="index" class="desktop-skeleton-item">
              <div class="skeleton-button"></div>
            </div>
          </div>

          <!-- Categorías dinámicas -->
          <template v-else>
            <!-- Links fijos -->
             <div class="desktop-menu-item">
              <a href="/blog" class="desktop-link" @click="closeDesktopMenu">
                BLOG
              </a>
            </div>
            <div class="desktop-menu-item">
              <a href="/productos" class="desktop-link" @click="closeDesktopMenu">
                TODOS LOS PRODUCTOS
              </a>
            </div>

            <!-- Categorías padre -->
            <template v-for="category in parentCategories" :key="category.id">
              <!-- Categoría con subcategorías -->
              <div v-if="hasSubcategories(category.id)" class="accordion-item border-0">
                <h2 class="accordion-header" :id="'desktopHeading' + category.id">
                  <button class="accordion-button collapsed desktop-link" type="button" data-bs-toggle="collapse"
                    :data-bs-target="'#desktopCollapse' + category.id">
                    {{ category.name.toUpperCase() }}
                  </button>
                </h2>
                <div :id="'desktopCollapse' + category.id" class="accordion-collapse collapse"
                  :aria-labelledby="'desktopHeading' + category.id" data-bs-parent="#desktopMenuAccordion">
                  <div class="accordion-body p-0">
                    <div class="submenu-items">
                      <a
                        :href="categoryProductsHref(category.name)"
                        class="submenu-link subcategory-parent-link"
                        @click="closeDesktopMenu"
                      >
                        Ver todo · {{ category.name }}
                      </a>
                      <!-- Subcategorías (hijas) -->
                      <template v-for="subcat in getDirectSubcategories(category.id)" :key="subcat.id">
                        <!-- Subcategoría con nietas -->
                        <div v-if="hasSubcategories(subcat.id)" class="subcategory-with-children mb-3">
                          <a :href="categoryProductsHref(subcat.name)" class="submenu-link subcategory-parent-link"
                            @click="closeDesktopMenu">
                            {{ subcat.name }}
                          </a>
                          <div class="subcategory-children ps-3 mt-2">
                            <a v-for="grandchild in getDirectSubcategories(subcat.id)" :key="grandchild.id"
                              :href="categoryProductsHref(grandchild.name)" class="submenu-link subgrandchild-link"
                              @click="closeDesktopMenu">
                              {{ grandchild.name }}
                            </a>
                          </div>
                        </div>
                        <!-- Subcategoría sin nietas -->
                        <a v-else :href="categoryProductsHref(subcat.name)" class="submenu-link"
                          @click="closeDesktopMenu">
                          {{ subcat.name }}
                        </a>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Categoría sin subcategorías -->
              <div v-else class="desktop-menu-item">
                <a :href="categoryProductsHref(category.name)" class="desktop-link" @click="closeDesktopMenu">
                  {{ category.name.toUpperCase() }}
                </a>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>

    <!-- Overlay for desktop menu -->
    <div class="desktop-offcanvas-backdrop" :class="{ show: isDesktopMenuOpen }" @click="closeDesktopMenu"></div>

    <!-- Mobile Offcanvas Menu -->
    <div class="offcanvas-menu" :class="{ show: isMobileMenuOpen }">
      <div class="offcanvas-header">
        <div class="d-flex align-items-center">
          <h5 class="offcanvas-title">Categorías</h5>
        </div>
        <button
          type="button"
          class="btn-close"
          @click="closeMobileMenu"
          aria-label="Close"
        ></button>
      </div>

      <div class="offcanvas-body">
        <!-- Mobile Search Bar -->
        <div class="search-container mb-4 mx-0">
          <form @submit.prevent="handleSearch" class="input-group">
            <input
              type="text"
              class="form-control search-input fs-7"
              placeholder="Buscar productos..."
              v-model="searchQuery"
              aria-label="Search products"
              @input="handleMobileSearchInput"
              @focus="handleMobileSearchFocus"
              @blur="handleMobileSearchBlur"
            />
            <button class="btn search-btn" type="submit" aria-label="Search">
              <i class="fas fa-search"></i>
            </button>
          </form>
          <div
            v-if="mobileShowSuggestions"
            class="mobile-search-suggestions"
            @mousedown.prevent
          >
            <div v-if="mobileIsSearching" class="mobile-suggest-loading">
              <div class="mobile-suggest-skeleton" v-for="n in 4" :key="`mobile-skel-${n}`">
                <div class="mobile-suggest-skeleton-img"></div>
                <div class="mobile-suggest-skeleton-lines">
                  <div class="mobile-suggest-skeleton-line"></div>
                  <div class="mobile-suggest-skeleton-line short"></div>
                </div>
              </div>
            </div>
            <template v-else>
              <div v-if="mobileSearchResults.length" class="mobile-suggest-list">
                <button
                  v-for="product in mobileSearchResults"
                  :key="`mobile-suggest-${product.id}`"
                  type="button"
                  class="mobile-suggest-item"
                  @click="handleMobileSuggestionClick(product)"
                >
                  <span class="mobile-suggest-thumb">
                    <img
                      v-if="product.image"
                      :src="product.image"
                      :alt="product.name"
                      loading="lazy"
                    />
                    <span v-else class="mobile-suggest-thumb-placeholder">
                      <i class="fas fa-box"></i>
                    </span>
                  </span>
                  <span class="mobile-suggest-info">
                    <span class="mobile-suggest-name">{{ product.name }}</span>
                    <span v-if="product.brand" class="mobile-suggest-brand">{{ product.brand }}</span>
                  </span>
                  <span class="mobile-suggest-price">
                    {{ formatPrice(product.final_price || product.price, product.currency) }}
                  </span>
                </button>
                <button
                  type="button"
                  class="mobile-suggest-see-all"
                  @click="handleSearch"
                >
                  Ver todos los resultados
                </button>
              </div>
              <div v-else class="mobile-suggest-empty">
                <i class="fas fa-search"></i>
                <span>No encontramos productos para "{{ searchQuery.trim() }}"</span>
              </div>
            </template>
          </div>
        </div>

        <!-- User Account Link -->
        <div class="mobile-user-account mb-4">
          <a
            @click.prevent="handleUserAccount"
            href="#"
            class="d-flex align-items-center p-2 rounded-3"
          >
            <i class="fas fa-user me-3 fs-5"></i>
            <div>
              <span class="d-block fw-medium">{{ username }}</span>
              <small class="text-muted">Mi cuenta</small>
            </div>
            <i class="fas fa-chevron-right ms-auto"></i>
          </a>
        </div>

        <!-- Menu Accordion - Igual que en desktop -->
        <div class="mobile-menu accordion" id="mobileMenuAccordion">
          <!-- Skeleton Loaders -->
          <div v-if="isLoadingCategories" class="mobile-skeleton-menu">
            <div v-for="index in 5" :key="index" class="mobile-skeleton-item">
              <div class="skeleton-button"></div>
            </div>
          </div>
          
          <!-- Categorías dinámicas -->
          <template v-else>
            <div class="mobile-menu-item">
              <a href="/productos" class="mobile-link" @click="closeMobileMenu">
                TODOS LOS PRODUCTOS
              </a>
            </div>
           
            
            <!-- Categorías padre -->
            <template v-for="category in parentCategories" :key="category.id">
              <!-- Categoría con subcategorías -->
              <div v-if="hasSubcategories(category.id)" class="accordion-item border-0">
                <h2 class="accordion-header" :id="'heading' + category.id">
                  <button class="accordion-button collapsed mobile-link" 
                          type="button" 
                          data-bs-toggle="collapse" 
                          :data-bs-target="'#collapse' + category.id">
                    {{ category.name.toUpperCase() }}
                  </button>
                </h2>
                <div :id="'collapse' + category.id" 
                     class="accordion-collapse collapse" 
                     :aria-labelledby="'heading' + category.id" 
                     data-bs-parent="#mobileMenuAccordion">
                  <div class="accordion-body p-0">
                    <div class="submenu-items mobile-submenu-items">
                      <a
                        :href="categoryProductsHref(category.name)"
                        class="mobile-subcategory-link subcategory-parent-link"
                        @click="closeMobileMenu"
                      >
                        Ver todo · {{ category.name }}
                      </a>
                      <!-- Subcategorías (hijas) -->
                      <template v-for="subcat in getDirectSubcategories(category.id)" :key="subcat.id">
                        <!-- Subcategoría con nietas -->
                        <div v-if="hasSubcategories(subcat.id)" class="subcategory-with-children mb-3">
                          <a :href="categoryProductsHref(subcat.name)" 
                             class="mobile-subcategory-link subcategory-parent-link"
                             @click="closeMobileMenu">
                            {{ subcat.name }}
                          </a>
                          <div class="mobile-subcategory-children ps-3 mt-2">
                            <a v-for="grandchild in getDirectSubcategories(subcat.id)" 
                               :key="grandchild.id"
                               :href="categoryProductsHref(grandchild.name)" 
                               class="mobile-grandchild-link subgrandchild-link"
                               @click="closeMobileMenu">
                              {{ grandchild.name }}
                            </a>
                          </div>
                        </div>
                        <!-- Subcategoría sin nietas -->
                        <a v-else
                           :href="categoryProductsHref(subcat.name)" 
                           class="mobile-subcategory-link"
                           @click="closeMobileMenu">
                          {{ subcat.name }}
                        </a>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Categoría sin subcategorías -->
              <div v-else class="mobile-menu-item">
                <a :href="categoryProductsHref(category.name)" 
                   class="mobile-link" 
                   @click="closeMobileMenu">
                  {{ category.name.toUpperCase() }}
                </a>
              </div>
            </template>
          </template>
        </div>
      </div>

      <!-- Social Links Footer -->
      <div class="offcanvas-footer">
        <div class="d-flex justify-content-between align-items-center">
          <div class="social-links-mobile">
            <a
              v-if="tiktokUrl"
              :href="tiktokUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="social-link-mobile"
              aria-label="Abrir TikTok de Fix Glass"
            >
              <i class="fab fa-tiktok" aria-hidden="true"></i>
            </a>
            <a
              v-if="instagramUrl"
              :href="instagramUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="social-link-mobile"
              aria-label="Abrir Instagram de Fix Glass"
            >
              <i class="fab fa-instagram" aria-hidden="true"></i>
            </a>
            <a
              :href="whatsappHref"
              target="_blank"
              rel="noopener noreferrer"
              class="social-link-mobile"
              aria-label="Enviar mensaje por WhatsApp a Fix Glass"
            >
              <i class="fab fa-whatsapp" aria-hidden="true"></i>
            </a>
          </div>
          <small class="text-muted">© {{ new Date().getFullYear() }}</small>
        </div>
      </div>
    </div>

    <!-- Overlay for mobile menu -->
    <div class="offcanvas-backdrop" :class="{ show: isMobileMenuOpen }" @click="closeMobileMenu"></div>

    <!-- Search Drawer -->
    <SearchDrawer :is-open="isSearchDrawerOpen" @close="closeSearchDrawer" />

    <!-- Mini Cart Drawer -->
    <MiniCartDrawer :is-open="isMiniCartOpen" @close="closeMiniCart" />
  </div>
</template>

<script>
import { computed, ref, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { getCategories } from '@/services/categories';
import { getSearchSuggestions } from '@/services/products';
import MiniCartDrawer from './MiniCartDrawer.vue';
import SearchDrawer from './SearchDrawer.vue';
import MarqueeBanner from '@/components/home/MarqueeBanner.vue';
import { useSiteContact } from '@/composables/useSiteContact';
import brand from '@/config/brand';

/** Orden de categorías padre en la barra (debe coincidir con la migración de datos). */
const NAV_PARENT_CATEGORY_ORDER = [
  'Celulares y tablets',
  'Gaming y consolas',
  'Audio',
  'Computación',
  'Accesorios',
  'Redes y smart home',
];

/** Evita que el menú horizontal con overflow:hidden recorte los dropdowns (Bootstrap 5 + Popper). */
const NAV_ROW_DROPDOWN_POPPER_FIXED = JSON.stringify({ strategy: 'fixed' });

export default {
  name: "NavbarComponent",
  components: { MiniCartDrawer, SearchDrawer, MarqueeBanner },
  data() {
    return {
      storeName: brand.storeName,
      marqueeItems: [
        { text: 'Celulares y tecnología' },
        { text: 'Gaming y consolas' },
        { text: 'Envíos a todo el país' },
        { text: 'Cuotas sin interés' },
        { text: 'Garantía oficial' },
        { text: 'Ofertas imperdibles' },
      ],
      navbarSearchQuery: "",
      navbarSearchResults: [],
      navbarIsSearching: false,
      navbarShowSuggestions: false,
      navbarSearchTimeout: null,
      navbarBlurTimeout: null,
      searchQuery: "",
      mobileSearchResults: [],
      mobileIsSearching: false,
      mobileShowSuggestions: false,
      mobileSearchTimeout: null,
      mobileBlurTimeout: null,
      activeDropdown: null,
      isMobileMenuOpen: false,
      isDesktopMenuOpen: false,
      isMiniCartOpen: false,
      isSearchDrawerOpen: false,
      categories: [],
      isLoadingCategories: false,
      categoryError: null,
      navRowDropdownPopperFixed: NAV_ROW_DROPDOWN_POPPER_FIXED,
      tiktokUrl: brand.socialTiktok,
    };
  },
  created() {
    // Mejorar el logging para depuración
    this.loadCategories();
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const cartCount = computed(() => store.getters.cartCount);
    const username = ref("");
    const isAdmin = ref(false);
    const isDistributor = ref(false);
    const isAuthenticated = ref(false);

    const updateUserInfo = () => {
      const token = localStorage.getItem("accessToken");
      isAuthenticated.value = !!token;
      isAdmin.value = localStorage.getItem("isAdmin") === "true";
      isDistributor.value = localStorage.getItem("customerType") === "DISTRIBUTOR";

      if (isAuthenticated.value) {
        const firstName = localStorage.getItem("userFirstName");
        const lastName = localStorage.getItem("userLastName");
        if (firstName && lastName) {
          username.value = `${firstName} ${lastName}`;
        } else {
          username.value = localStorage.getItem("username") || "Usuario";
        }
      } else {
        username.value = "";
      }
    };

    onMounted(() => {
      updateUserInfo();
      window.addEventListener("storage", updateUserInfo);
    });

    // Limpiar el event listener cuando el componente se desmonta
    onUnmounted(() => {
      window.removeEventListener("storage", updateUserInfo);
    });

    const { contactMailto, whatsappHref, instagramUrl, contactPhoneDisplay, telHref } = useSiteContact();

    return {
      cartCount,
      router,
      route,
      username,
      isAdmin,
      isDistributor,
      isAuthenticated,
      contactMailto,
      whatsappHref,
      instagramUrl,
      contactPhoneDisplay,
      telHref,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.updateNavbarHeightVariables();
    window.addEventListener("resize", this.updateNavbarHeightVariables);
    window.addEventListener("mobile-menu:open", this.openMobileMenu);

    // Initialize Bootstrap components if needed
    this.initBootstrapComponents();

    // Add scroll event listener for transparent navbar
    window.addEventListener("scroll", this.handleScroll);
    // Apply scrolled state immediately if not on home page
    this.handleScroll();
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("resize", this.updateNavbarHeightVariables);
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("mobile-menu:open", this.openMobileMenu);
    if (this.navbarSearchTimeout) clearTimeout(this.navbarSearchTimeout);
    if (this.mobileSearchTimeout) clearTimeout(this.mobileSearchTimeout);
    if (this.navbarBlurTimeout) clearTimeout(this.navbarBlurTimeout);
    if (this.mobileBlurTimeout) clearTimeout(this.mobileBlurTimeout);
  },
  computed: {
    parentCategories() {
      return this.categories.filter(cat => !cat.parent);
    },
    parentCategoriesNavOrder() {
      const parents = this.parentCategories;
      return [...parents].sort((a, b) => {
        const ia = NAV_PARENT_CATEGORY_ORDER.indexOf(a.name);
        const ib = NAV_PARENT_CATEGORY_ORDER.indexOf(b.name);
        if (ia === -1 && ib === -1) return String(a.name).localeCompare(String(b.name), 'es');
        if (ia === -1) return 1;
        if (ib === -1) return -1;
        return ia - ib;
      });
    },
    formattedCartTotal() {
      const total = this.$store.getters.cartTotal || 0;
      try {
        return new Intl.NumberFormat('es-AR', {
          style: 'currency',
          currency: 'ARS',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(total);
      } catch {
        return `$${Number(total).toFixed(2)}`;
      }
    },
  },
  watch: {
    $route() {
      this.handleScroll();
    }
  },
  methods: {
    formatPrice(price, currency) {
      if (!price && price !== 0) return '';
      if (currency === 'USD') return `USD ${Number(price).toFixed(2)}`;
      return new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: 'ARS',
        maximumFractionDigits: 0,
      }).format(price);
    },
    categoryProductsRoute(categoryName) {
      return {
        path: "/productos",
        query: { category_name: categoryName },
      };
    },
    categoryProductsHref(categoryName) {
      return `/productos?category_name=${encodeURIComponent(categoryName || "")}`;
    },
    initBootstrapComponents() {
      // Initialize Bootstrap accordion if not using data attributes
      if (window.bootstrap && window.bootstrap.Collapse) {
        const accordionItems = document.querySelectorAll(".accordion-collapse");
        accordionItems.forEach((item) => {
          new window.bootstrap.Collapse(item, { toggle: false });
        });
      }
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      document.body.style.overflow = this.isMobileMenuOpen ? "hidden" : "";

      // Optional: Add animation effect
      const menuItems = document.querySelectorAll(
        ".mobile-link, .submenu-link"
      );
      if (this.isMobileMenuOpen) {
        menuItems.forEach((item, index) => {
          item.style.transitionDelay = `${index * 0.05}s`;
          item.style.opacity = 1;
          item.style.transform = "translateX(0)";
        });
      } else {
        menuItems.forEach((item) => {
          item.style.transitionDelay = "0s";
          item.style.opacity = 0;
          item.style.transform = "translateX(20px)";
        });
      }
    },

    openMobileMenu() {
      if (this.isMobileMenuOpen) return;
      this.toggleMobileMenu();
    },

    toggleDesktopMenu() {
      this.isDesktopMenuOpen = !this.isDesktopMenuOpen;
      document.body.style.overflow = this.isDesktopMenuOpen ? "hidden" : "";

      // Animación similar a la del menú mobile
      const menuItems = document.querySelectorAll(
        ".desktop-link, .submenu-link"
      );
      if (this.isDesktopMenuOpen) {
        menuItems.forEach((item, index) => {
          item.style.transitionDelay = `${index * 0.05}s`;
          item.style.opacity = 1;
          item.style.transform = "translateX(0)";
        });
      } else {
        menuItems.forEach((item) => {
          item.style.transitionDelay = "0s";
          item.style.opacity = 0;
          item.style.transform = "translateX(20px)";
        });
      }
    },

    closeDesktopMenu() {
      if (this.isDesktopMenuOpen) {
        this.isDesktopMenuOpen = false;
        document.body.style.overflow = "";

        // Cerrar acordeones abiertos
        const accordions = document.querySelectorAll('.accordion-collapse.show');
        accordions.forEach(accordion => {
          if (window.bootstrap && window.bootstrap.Collapse) {
            const bsCollapse = new window.bootstrap.Collapse(accordion);
            bsCollapse.hide();
          }
        });

        // Reset menu items animation
        const menuItems = document.querySelectorAll('.desktop-link, .submenu-link');
        menuItems.forEach((item) => {
          item.style.transitionDelay = "0s";
          item.style.opacity = 0;
          item.style.transform = "translateX(20px)";
        });
      }
    },

    closeMobileMenu() {
      if (this.isMobileMenuOpen) {
        this.isMobileMenuOpen = false;
        document.body.style.overflow = "";
        this.resetMobileSuggestions();

        // Cerrar todos los acordeones abiertos
        const accordions = document.querySelectorAll('.accordion-collapse.show');
        accordions.forEach(accordion => {
          if (window.bootstrap && window.bootstrap.Collapse) {
            const bsCollapse = new window.bootstrap.Collapse(accordion);
            bsCollapse.hide();
          }
        });

        // Reset menu items animation
        const menuItems = document.querySelectorAll('.mobile-link, .submenu-link');
        menuItems.forEach((item) => {
          item.style.transitionDelay = "0s";
          item.style.opacity = 0;
          item.style.transform = "translateX(20px)";
        });
      }
    },

    toggleSearchDrawer() {
      this.isSearchDrawerOpen = !this.isSearchDrawerOpen;
    },

    closeSearchDrawer() {
      this.isSearchDrawerOpen = false;
    },
    updateNavbarHeightVariables() {
      // Get navbar wrapper element
      const navbarWrapper = document.querySelector(".navbar-wrapper");
      if (navbarWrapper) {
        // Calculate navbar height
        const navbarHeight = navbarWrapper.offsetHeight;

        // Set CSS variables
        document.documentElement.style.setProperty(
          "--navbar-total-height",
          `${navbarHeight}px`
        );

        // Also set a mobile version if screen is smaller
        if (window.innerWidth <= 991.98) {
          document.documentElement.style.setProperty(
            "--navbar-total-height-mobile",
            `${navbarHeight}px`
          );

          // Set optimized hero height for mobile based on screen height
          const screenHeight = window.innerHeight;
          let optimizedHeroHeight;

          if (window.innerWidth <= 480) {
            optimizedHeroHeight = Math.max(screenHeight * 0.6, 350); // 60% of screen or at least 350px
          } else if (window.innerWidth <= 768) {
            optimizedHeroHeight = Math.max(screenHeight * 0.7, 400); // 70% of screen or at least 400px
          } else {
            optimizedHeroHeight = Math.max(screenHeight * 0.7, 450); // 70% of screen or at least 450px
          }

          document.documentElement.style.setProperty(
            "--hero-height",
            `${optimizedHeroHeight}px`
          );

          // Set a background color that matches the products section
          document.documentElement.style.setProperty(
            "--hero-bg-color",
            "#f8f8f8"
          );
        } else {
          // Reset hero height for desktop
          document.documentElement.style.removeProperty("--hero-height");
          document.documentElement.style.removeProperty("--hero-bg-color");
        }
      }
    },
    handleResize() {
      if (window.innerWidth >= 992 && this.isMobileMenuOpen) {
        this.closeMobileMenu();
      }
    },
    handleSearch() {
      if (this.searchQuery.trim()) {
        this.router.push({
          path: "/productos",
          query: { search: this.searchQuery.trim() },
        });
        this.resetMobileSuggestions();
        this.closeMobileMenu();
      }
    },
    handleNavbarSearch() {
      const q = this.navbarSearchQuery.trim();
      if (!q) {
        this.toggleSearchDrawer();
        return;
      }
      this.router.push({
        path: "/productos",
        query: { search: q },
      });
      this.navbarSearchQuery = "";
      this.resetNavbarSuggestions();
    },
    clearNavbarSearch() {
      this.navbarSearchQuery = '';
      this.resetNavbarSuggestions();
    },
    handleNavbarSearchInput() {
      const q = this.navbarSearchQuery.trim();
      if (this.navbarSearchTimeout) clearTimeout(this.navbarSearchTimeout);
      if (q.length < 2) {
        this.resetNavbarSuggestions();
        return;
      }

      this.navbarIsSearching = true;
      this.navbarShowSuggestions = true;

      this.navbarSearchTimeout = setTimeout(async () => {
        try {
          const data = await getSearchSuggestions(q);
          const results = data.results || [];
          this.navbarSearchResults = results.slice(0, 6);
        } catch {
          this.navbarSearchResults = [];
        } finally {
          this.navbarIsSearching = false;
        }
      }, 250);
    },
    handleNavbarSearchFocus() {
      if (this.navbarBlurTimeout) clearTimeout(this.navbarBlurTimeout);
      if (this.navbarSearchQuery.trim().length >= 2) {
        this.navbarShowSuggestions = true;
      }
    },
    handleNavbarSearchBlur() {
      this.navbarBlurTimeout = setTimeout(() => {
        this.navbarShowSuggestions = false;
      }, 150);
    },
    handleNavbarSuggestionClick(product) {
      this.router.push(`/producto/${product.id}`);
      this.navbarSearchQuery = '';
      this.resetNavbarSuggestions();
    },
    resetNavbarSuggestions() {
      this.navbarShowSuggestions = false;
      this.navbarIsSearching = false;
      this.navbarSearchResults = [];
    },
    handleMobileSearchInput() {
      const q = this.searchQuery.trim();
      if (this.mobileSearchTimeout) clearTimeout(this.mobileSearchTimeout);
      if (q.length < 2) {
        this.resetMobileSuggestions();
        return;
      }

      this.mobileIsSearching = true;
      this.mobileShowSuggestions = true;

      this.mobileSearchTimeout = setTimeout(async () => {
        try {
          const data = await getSearchSuggestions(q);
          const results = data.results || [];
          this.mobileSearchResults = results.slice(0, 6);
        } catch {
          this.mobileSearchResults = [];
        } finally {
          this.mobileIsSearching = false;
        }
      }, 250);
    },
    handleMobileSearchFocus() {
      if (this.mobileBlurTimeout) clearTimeout(this.mobileBlurTimeout);
      if (this.searchQuery.trim().length >= 2) {
        this.mobileShowSuggestions = true;
      }
    },
    handleMobileSearchBlur() {
      this.mobileBlurTimeout = setTimeout(() => {
        this.mobileShowSuggestions = false;
      }, 150);
    },
    handleMobileSuggestionClick(product) {
      this.router.push(`/producto/${product.id}`);
      this.searchQuery = '';
      this.resetMobileSuggestions();
      this.closeMobileMenu();
    },
    resetMobileSuggestions() {
      this.mobileShowSuggestions = false;
      this.mobileIsSearching = false;
      this.mobileSearchResults = [];
    },
    handleUserAccount() {
      if (this.isAuthenticated) {
        if (this.isAdmin) {
          this.router.push("/configuracion/productos");
        } else {
          this.router.push("/configuracion/my-orders");
        }
      } else {
        this.router.push("/iniciar-sesion");
      }
      this.closeMobileMenu();
    },
    handleScroll() {
      const navbar = document.querySelector(".navbar-main-bar");
      const navRow = document.querySelector(".navbar-nav-row");
      const wrapper = document.querySelector(".navbar-wrapper");
      const promoBanner = document.querySelector(".promo-banner");
      const isHome = this.route && this.route.path === "/";
      const isAboutUs = this.route && this.route.path === "/nosotros";
      const shouldHideMarquee = window.scrollY > 100;

      if ((!isHome && !isAboutUs) || window.scrollY > 150) {
        if (navbar) navbar.classList.add("navbar-scrolled");
        if (navRow) navRow.classList.add("navbar-nav-row--scrolled");
        if (wrapper) wrapper.classList.add("navbar-wrapper--scrolled");
        if (promoBanner) promoBanner.classList.add("scrolled");
      } else {
        if (navbar) navbar.classList.remove("navbar-scrolled");
        if (navRow) navRow.classList.remove("navbar-nav-row--scrolled");
        if (wrapper) wrapper.classList.remove("navbar-wrapper--scrolled");
        if (promoBanner) promoBanner.classList.remove("scrolled");
      }

      if (promoBanner) {
        promoBanner.classList.toggle("promo-banner--hidden", shouldHideMarquee);
      }
    },
    getCategoryIcon(categoryName) {
      const icons = {
        'CELULARES Y TABLETS': 'fas fa-mobile-screen-button',
        'CELULARES': 'fas fa-mobile-alt',
        'TABLETS': 'fas fa-tablet-screen-button',
        'REPUESTOS': 'fas fa-screwdriver-wrench',
        'PANTALLAS': 'fas fa-mobile-screen',
        'MÓDULOS': 'fas fa-microchip',
        'BATERÍAS': 'fas fa-battery-full',
        'ACCESORIOS': 'fas fa-headphones',
        'FUNDAS': 'fas fa-shield-alt',
        'VIDRIOS TEMPLADOS': 'fas fa-mobile-alt',
        'CARGADORES': 'fas fa-plug',
        'CABLES': 'fas fa-bolt',
        'AUDIO': 'fas fa-headphones-simple',
        'GAMING Y CONSOLAS': 'fas fa-gamepad',
        'COMPUTACIÓN': 'fas fa-laptop',
        'REDES Y SMART HOME': 'fas fa-wifi',
        'OTROS ARTÍCULOS': 'fas fa-boxes'
      };
      return icons[categoryName] || 'fas fa-tag';
    },

    async loadCategories() {
      try {
        this.isLoadingCategories = true;
        console.log('Cargando categorías...');

        const response = await getCategories();
        this.categories = response.results || response;

        // Process categories and add slugs if missing
        this.categories = this.categories.map(category => ({
          ...category,
          slug: category.slug || this.generateSlug(category.name)
        }));

        console.log('Categorías procesadas:', this.categories);

      } catch (error) {
        console.error('Error loading categories:', error);
        this.categoryError = 'Error al cargar las categorías';
      } finally {
        this.isLoadingCategories = false;
        // El menú de categorías cambia la altura del navbar → recalcular
        // las variables (--navbar-total-height / -mobile) que usan la ruleta,
        // el registro y el hero.
        this.updateNavbarHeightVariables();
      }
    },

    // Generate slug client side if needed
    generateSlug(name) {
      return name
        .toLowerCase()
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/[^\w-]+/g, '')        // Remove all non-word chars
        .replace(/--+/g, '-')           // Replace multiple - with single -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '');            // Trim - from end of text
    },

    // Esta función es crítica para comprobar si una categoría tiene subcategorías
    hasSubcategories(categoryId) {
      const hasChildren = this.categories.some(cat => cat.parent === categoryId);
      return hasChildren;
    },

    // Asegurar que estas funciones funcionan correctamente
    getDirectSubcategories(parentId) {
      const subcats = this.categories.filter(cat => cat.parent === parentId);
      return subcats;
    },

    // Método mejorado para obtener subcategorías anidadas
    getNestedSubcategories(parentId) {
      // Obtener las subcategorías directas
      const directSubcats = this.getDirectSubcategories(parentId);

      // Para cada subcategoría directa, agregar sus propias subcategorías
      return directSubcats.map(subcat => ({
        ...subcat,
        children: this.categories.filter(cat => cat.parent === subcat.id)
      }));
    },

    toggleMiniCart() {
      this.isMiniCartOpen = !this.isMiniCartOpen;
    },
    closeMiniCart() {
      this.isMiniCartOpen = false;
    },
  },
};
</script>

<style scoped>
/* Estilos del banner promocional */
.promo-banner {
  background-color: #0a0a0a;
  padding: 0;
  font-size: 14px;
  max-height: 80px;
  overflow: hidden;
  transition: background-color 0.3s ease, color 0.3s ease, transform 0.35s ease, opacity 0.35s ease, max-height 0.35s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.promo-banner--hidden {
  transform: translateY(-8px);
  opacity: 0;
  pointer-events: none;
  max-height: 0;
  border-bottom-color: transparent;
}

.promo-banner--with-marquee {
  display: flex;
  align-items: stretch;
  overflow: hidden;
}

.promo-banner__marquee {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}

/* Gradiente rojo en el borde izquierdo (dentro del área de la marquesina) */
.promo-banner__marquee::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: min(42vw, 240px);
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(
    90deg,
    rgba(69, 10, 10, 0.92) 0%,
    rgba(127, 29, 29, 0.65) 22%,
    rgba(185, 28, 28, 0.28) 55%,
    transparent 100%
  );
}

.promo-banner__marquee :deep(.marquee-banner) {
  position: relative;
  z-index: 2;
}

.promo-banner__auth {
  align-self: stretch;
  display: flex;
  align-items: center;
  border-left: 1px solid rgba(255, 255, 255, 0.12);
  background-color: var(--marquee-bg, var(--primary-color));
}

.promo-link--compact {
  font-size: 0.72rem;
  font-weight: 600;
  white-space: nowrap;
}

.promo-banner.scrolled {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.promo-banner.scrolled .text-white {
  color: #fff !important;
}

.promo-banner.scrolled a.text-white {
  color: #fff !important;
}

.promo-banner.scrolled a.text-white:hover {
  color: var(--primary-color) !important;
  opacity: 1;
}

.promo-care-link:hover {
  color: var(--primary-color) !important;
}

.promo-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.35);
}

.promo-link {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.promo-link:hover {
  color: var(--primary-color);
}

.promo-icon {
  align-items: center;
  justify-content: center;
}

.social-links {
  display: flex;
  gap: 15px;
}

.social-link {
  color: var(--text-dark);
  text-decoration: none;
  transition: opacity 0.3s ease;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-link:hover {
  opacity: 0.8;
  background-color: rgba(255, 255, 255, 0.2);
}

.timer-container {
  display: flex;
  align-items: center;
}

.timer-box {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 2px 6px;
  margin: 0 4px;
  font-weight: bold;
}

/* Estilos del menú superior */
.top-menu {
  background-color: #f8f9fa;
  padding: 8px 20px;
  font-size: 13px;
}

.top-menu-links {
  display: flex;
  align-items: center;
}

.top-menu-link {
  color: #6c757d;
  margin-right: 15px;
  text-decoration: none;
}

.top-menu-link:hover {
  color: #6a42b9;
}

.delivery-time {
  color: #6c757d;
  margin-left: 10px;
}

.highlight {
  color: #ff6b6b;
  font-weight: bold;
}

.top-menu-right {
  display: flex;
  align-items: center;
}

.language-selector,
.currency-selector {
  margin-right: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.language-selector i,
.currency-selector i {
  font-size: 10px;
  margin-left: 5px;
}

.tracking-link {
  color: #6c757d;
  text-decoration: none;
}

/* Estilos del navbar principal */
.navbar-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1050;
  background: #0a0a0a;
}

.mobile-topbar {
  display: none;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.9rem 0.65rem;
  background: #0a0a0a;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.mobile-topbar__logo {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

.mobile-topbar__logo-img {
  max-width: 120px;
  height: auto;
  display: block;
}

.mobile-topbar__action {
  position: relative;
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.05rem;
}

.mobile-topbar__badge {
  position: absolute;
  top: 0.2rem;
  right: 0.15rem;
  min-width: 1.15rem;
  height: 1.15rem;
  border-radius: 999px;
  background: var(--primary-color);
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.3rem;
}

@media (max-width: 991.98px) {
  .mobile-topbar {
    display: flex;
  }

  .navbar-main-bar,
  .navbar-nav-row,
  .desktop-offcanvas-menu {
    display: none !important;
  }
}

.navbar-main-bar {
  padding: 0;
  background-color: #0a0a0a !important;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  box-shadow: none;
  position: relative;
  z-index: 1060;
}

.navbar-main-row {
  min-height: 56px;
  justify-content: flex-start;
}

.navbar-main-row__start {
  min-width: 0;
}

@media (max-width: 991.98px) {
  .navbar-main-row__start {
    margin-right: auto;
    max-width: calc(100% - 8.5rem);
  }

  .navbar-main-row .navbar-brand {
    min-width: 0;
  }

  .navbar-main-row .brand-container {
    min-width: 0;
  }

  .navbar-main-row .logo-img {
    margin-right: 0;
  }
}

/* Estilo para navbar después de scroll — permanece oscuro */
.navbar-scrolled {
  background-color: rgba(10, 10, 10, 0.97) !important;
  color: #fff;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.navbar-main-bar .navbar-brand,
.navbar-main-bar .nav-actions,
.navbar-main-bar .navbar-svg-icon,
.mobile-icon-btn .navbar-svg-icon,
.user-account-icon .navbar-svg-icon,
.cart-block {
  color: #fff !important;
}

.navbar-svg-icon {
  transition: color 0.3s ease;
  display: block;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
}

.cart-block .navbar-svg-icon {
  width: 24px;
  height: 24px;
}

.nav-link {
  font-weight: 300;
}

.navbar-scrolled .navbar-brand,
.navbar-scrolled .nav-actions,
.navbar-scrolled .navbar-svg-icon,
.navbar-scrolled .cart-block {
  color: #fff !important;
}

.nav-link:hover {
  opacity: 0.75;
  background: none;
}

.navbar-scrolled .desktop-search-btn .navbar-svg-icon {
  color: #fff !important;
}

/* Búsqueda tipo píldora (desktop) */
.navbar-search-pill {
  max-width: 560px;
}

.navbar-search-inner {
  display: flex;
  align-items: center;
  background: #141414;
  border: 1px solid var(--black-color-3);
  border-radius: 9999px;
  overflow: visible;
  min-height: 46px;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.navbar-search-inner:focus {
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.25);
  border-color: var(--primary-light);
}

.navbar-search-field {
  flex: 1;
  border: none;
  background: transparent;
  color: #fff;
  padding: 0 1rem 0 1.25rem;
  font-size: 0.95rem;
  outline: none;
  min-width: 0;
  appearance: none;
}

.navbar-search-field::-webkit-search-cancel-button,
.navbar-search-field::-ms-clear {
  appearance: none;
  display: none;
}

.navbar-search-field::-moz-search-clear {
  appearance: none;
  display: none;
}

.navbar-search-field::placeholder {
  color: rgba(255, 255, 255, 0.45);
}

.navbar-search-submit {
  flex-shrink: 0;
  width: 48px;
  height: 46px;
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.2s ease, background 0.2s ease;
}

.navbar-search-submit:hover {
  color: var(--primary-color);
  background: rgba(220, 38, 38, 0.08);
}

.navbar-search-clear {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  margin-right: 4px;
  border: none;
  border-radius: 999px;
  background: rgba(220, 38, 38, 0.15);
  color: #dc2626;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.navbar-search-clear:hover {
  background: rgba(220, 38, 38, 0.25);
  color: #f87171;
}

.user-account-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.user-account-icon:hover {
  background-color: rgba(255, 255, 255, 0.08);
}

.cart-block {
  padding: 0.25rem 0;
  cursor: pointer;
  border-radius: 8px;
  transition: opacity 0.2s ease;
}

.cart-block:hover {
  opacity: 0.92;
}

.cart-icon-wrap .navbar-svg-icon {
  display: block;
}

/* Fila de menú + dropdowns */
.navbar-nav-row {
  background-color: #0a0a0a;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  transition: background-color 0.3s ease;
  position: relative;
  z-index: 1040;
}

.navbar-nav-row--scrolled {
  background-color: rgba(10, 10, 10, 0.97);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.nav-row-menu-outer {
  min-width: 0;
}

/* Ancho = enlaces + Todos; en viewport angosto limita al 100% y recorta por overflow */
.nav-row-menu-cluster {
  --nav-row-col-gap: 1.5rem;
  width: max-content;
  max-width: 100%;
  min-width: 0;
  /* Mismo valor que column-gap del ul: un solo token para todo el bloque */
  column-gap: var(--nav-row-col-gap);
}

.nav-row-menu-overflow {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
}

.nav-row-menu {
  width: max-content;
  max-width: none;
  gap: 0.25rem var(--nav-row-col-gap);
  flex-wrap: nowrap !important;
}

.nav-row-menu-tail {
  margin-left: 0;
}

.nav-row-item {
  position: relative;
  flex-shrink: 0;
}

.nav-row-link {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.5rem;
  color: #fff !important;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: capitalize;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: color 0.2s ease;
}

.nav-row-link:hover,
.nav-row-link:focus,
.nav-row-link.show {
  color: var(--primary-color) !important;
}

.nav-row-link.dropdown-toggle::after {
  margin-left: 0.35rem;
  vertical-align: 0.2em;
  border-top-color: rgba(255, 255, 255, 0.7);
}

.nav-row-link.dropdown-toggle:hover::after,
.nav-row-link.dropdown-toggle.show::after {
  border-top-color: var(--primary-color);
}

.nav-row-link-plain::after {
  display: none !important;
}

.dropdown-menu-nav {
  border-radius: 10px;
  padding: 0.5rem 0;
  min-width: 200px;
  margin-top: 0.35rem !important;
}

.nav-row-item.dropdown:hover > .dropdown-menu-nav,
.nav-row-item.dropdown:focus-within > .dropdown-menu-nav {
  display: block;
}

.dropdown-menu-nav .dropdown-item {
  color: #1a1a1a;
  font-size: 0.9rem;
  font-weight: 500;
  padding: 0.5rem 1.15rem;
}

.dropdown-menu-nav .dropdown-item:hover,
.dropdown-menu-nav .dropdown-item:focus {
  background-color: rgba(220, 38, 38, 0.08);
  color: var(--primary-color);
}
.account-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.account-label {
  font-weight: 500;
  font-size: 0.9rem;
  color: #fff;
}

.brand-container {
  display: flex;
  align-items: center;
}

.logo-img {
  width: 180px;
  height: auto;
  margin-right: 8px;
}

.brand-name {
  font-size: 20px;
  font-weight: bold;
  color: var(--navbar-text);
}

.location-selector {
  display: flex;
  align-items: center;
  margin-left: 15px;
  font-size: 13px;
  color: var(--navbar-icon);
  cursor: pointer;
  border-left: 1px solid var(--navbar-border);
  padding-left: 15px;
}

.location-selector i {
  margin-right: 5px;
  color: var(--primary-color);
}

.location-text {
  font-weight: bold;
  margin: 0 5px;
}

/* Barra de búsqueda */
.search-container {
  flex-grow: 1;
  max-width: 500px;
  margin: 0 30px;
}

.search-input {
  border-radius: 20px 0 0 20px;
  border: 1px solid var(--navbar-border);
  padding-left: 15px;
  height: 42px;
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}

.search-btn {
  background-color: var(--primary-color) !important;
  color: var(--white-color) !important;
  border-radius: 0 20px 20px 0;
  border: none;
  width: 50px;
  transition: background-color 0.3s ease;
}

.search-btn:hover {
  background-color: var(--primary-dark) !important;
}

.navbar-scrolled .search-btn {
  background-color: var(--primary-color) !important;
}

/* Íconos de acciones */
.nav-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-left: 0;
}

/* Transiciones para los íconos de acciones */
.nav-actions i,
.user-account,
.cart-icon,
.account-label,
.account-text {
  transition: color 0.3s ease;
}

.user-account {
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.user-account:hover {
  opacity: 0.8;
}

.account-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.account-label {
  font-weight: 500;
  font-size: 0.9rem;
  color: var(--text-dark);
}

.account-role {
  font-size: 0.7rem;
  padding: 2px 6px;
  border-radius: 12px;
}

.wishlist-icon,
.cart-icon {
  position: relative;
  margin-left: 20px;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: background-color 0.2s ease;
  text-decoration: none;
}

.wishlist-icon i,
.cart-icon i {
  font-size: 22px;
  color: var(--navbar-icon);
}

.wishlist-icon:hover,
.cart-icon:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.cart-icon-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.wishlist-count,
.cart-count {
  position: absolute;
  top: -6px;
  right: -8px;
  background-color: var(--primary-color) !important;
  color: var(--white-color);
  font-size: 10px;
  font-weight: 700;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

/* Menú de categorías */
.category-menu {
  background-color: var(--navbar-bg);
  padding: 0 20px;
  position: relative;
  overflow: visible;
  transition: background-color 0.3s ease, color 0.3s ease;
}


.navbar-scrolled+.category-menu {
  background-color: #0a0a0a;
}

.navbar-scrolled+.category-menu .category-item a {
  color: #fff;
}

.navbar-scrolled+.category-menu .category-item a:hover {
  color: var(--primary-color);
}

.category-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.category-item {
  margin-right: 25px;
  position: relative;
}

.category-item a {
  display: block;
  padding: 15px 0;
  color: var(--navbar-text);
  text-decoration: none;
  font-weight: 500;
  font-size: 0.85rem;
  text-transform: capitalize;
}

.category-item a:hover {
  color: var(--primary-color);
}

/* Mejoras a los estilos del dropdown */
.mega-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: max-content;
  min-width: 400px;
  max-width: 800px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
  padding: 20px;
  transform: translateY(10px);
  max-height: 80vh;
  overflow-y: auto;
}

.mega-dropdown.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-toggle .fa-chevron-down {
  font-size: 0.7rem;
  transition: transform 0.3s ease;
}

.dropdown-toggle::after {
  display: none;
}

.has-dropdown:hover .dropdown-toggle .fa-chevron-down {
  transform: rotate(-180deg);
}

.subcategories-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  width: 100%;
}

.subcategory-column {
  padding: 6px;
}

.subcategory-title {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: var(--text-dark);
  text-decoration: none;
  padding: 10px;
  border-radius: 6px;
  transition: all 0.2s ease;
  background-color: rgba(0, 0, 0, 0.04);
  margin-bottom: 0;
  width: 100%;
  white-space: normal;
  line-height: 1.2;
}

.subcategory-title:hover {
  background-color: rgba(0, 0, 0, 0.08);
  color: var(--primary-color);
  transform: translateX(5px);
}

.all-products {
  color: var(--primary-color) !important;
  font-weight: 600 !important;
}

/* Mobile Improvements */
@media (max-width: 991.98px) {
  .mega-dropdown {
    position: static;
    transform: none;
    box-shadow: none;
    padding: 0;
    max-width: 100%;
  }

  .mega-content {
    grid-template-columns: 1fr;
  }

  .category-section {
    padding: 12px;
    background: none;
  }

  .subcategories-grid {
    gap: 12px;
  }

  .category-main-title {
    font-size: 1rem;
    margin-bottom: 12px;
  }

  .subcategory-title {
    font-size: 0.9rem;
  }

  .subcategory-item {
    font-size: 0.85rem;
  }
}

/* Mobile menu and other existing styles */
.mobile-menu-toggle,
.mobile-icon-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.mobile-icon-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.navbar-scrolled .mobile-icon-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.navbar-scrolled .mobile-icon-btn i,
.navbar-scrolled .mobile-icon-btn .navbar-svg-icon {
  color: #fff !important;
}

.mobile-menu-toggle i.fa-times {
  transform: rotate(0deg);
}


/* Promo banner items */
.promo-item {
  display: flex;
  align-items: center;
}

/* Enhanced mobile menu appearance */
@media (max-width: 991.98px) {
  .navbar-main-bar {
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .logo-img {
    width: 120px;
  }

  .navbar-brand {
    margin-right: 0;
  }

  .nav-actions {
    gap: 0.35rem;
  }

  .navbar-svg-icon {
    width: 22px;
    height: 22px;
  }
}

/* ===== OFFCANVAS MENU (MOBILE) ===== */
.offcanvas-menu {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  max-width: 360px;
  height: 100vh;
  background-color: #fff;
  z-index: 1050;
  overflow-y: auto;
  transform: translateX(100%);
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
}

.offcanvas-menu.show {
  transform: translateX(0);
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  z-index: 1045;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.35s ease;
  pointer-events: none;
}

.offcanvas-backdrop.show {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.offcanvas-header {
  padding: 1.25rem 1.25rem 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.offcanvas-header .offcanvas-title {
  color: #111;
  font-weight: 700;
  font-size: 1.1rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin: 0;
}

.offcanvas-header .btn-close {
  filter: none;
  opacity: 0.5;
  transition: opacity 0.2s ease;
  flex-shrink: 0;
}

.offcanvas-header .btn-close:hover {
  opacity: 1;
}

.offcanvas-body {
  padding: 1.25rem;
  overflow-y: auto;
  flex: 1;
}

.offcanvas-footer {
  padding: 1rem 1.25rem;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}

/* Mobile user account */
.mobile-user-account {
  margin-bottom: 1.25rem !important;
}

.mobile-user-account a {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #111 !important;
  background-color: rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 0.85rem 1rem;
  transition: background-color 0.2s ease;
}

.mobile-user-account a:hover,
.mobile-user-account a:active {
  background-color: rgba(0, 0, 0, 0.07);
}

.mobile-user-account i.fas {
  font-size: 1.1rem;
  color: var(--primary-color) !important;
}

.mobile-user-account .text-muted {
  color: rgba(0,0,0,0.4) !important;
  font-size: 0.75rem;
}

.mobile-user-account .fa-chevron-right {
  color: rgba(0, 0, 0, 0.25) !important;
  font-size: 0.75rem;
}

/* Mobile search inside offcanvas */
.offcanvas-body .search-container {
  max-width: 100%;
  margin: 0 0 1.25rem;
}

.offcanvas-body .search-input {
  background-color: #f5f5f5 !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  color: #111 !important;
  border-radius: 8px 0 0 8px;
  height: 42px;
}

.offcanvas-body .search-input::placeholder {
  color: rgba(0, 0, 0, 0.35);
}

.offcanvas-body .search-input:focus {
  background-color: #fff !important;
  border-color: var(--primary-color) !important;
  box-shadow: none;
  outline: none;
}

.offcanvas-body .search-btn {
  background-color: var(--primary-color) !important;
  color: #fff !important;
  border-radius: 0 8px 8px 0;
  border: none;
  width: 46px;
}

/* Mobile nav links */
.mobile-link {
  display: flex;
  align-items: center;
  padding: 0.75rem 0.9rem;
  color: #111 !important;
  text-decoration: none !important;
  font-weight: 500;
  font-size: 0.85rem;
  letter-spacing: 0.03em;
  border-radius: 8px;
  transition: background-color 0.2s ease, color 0.2s ease;
  width: 100%;
}

.mobile-link:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #000 !important;
}

.mobile-menu-item {
  margin-bottom: 2px;
}

/* Mobile accordion (categories with subcategories) */
.offcanvas-menu .accordion-item {
  background: transparent;
  border: none !important;
  margin-bottom: 2px;
}

.offcanvas-menu .accordion-button {
  background-color: transparent !important;
  color: #111 !important;
  font-weight: 500;
  font-size: 0.85rem;
  letter-spacing: 0.03em;
  padding: 0.75rem 0.9rem;
  border-radius: 8px !important;
  box-shadow: none !important;
  border: none !important;
  width: 100%;
}

.offcanvas-menu .accordion-button:hover {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: #000 !important;
}

.offcanvas-menu .accordion-button:not(.collapsed) {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: var(--primary-color) !important;
}

.offcanvas-menu .accordion-button::after {
  filter: none;
  opacity: 0.5;
}

.offcanvas-menu .accordion-button:not(.collapsed)::after {
  filter: none;
  opacity: 1;
}

.offcanvas-menu .accordion-body {
  background: transparent;
  padding: 0 0 0.25rem;
}

/* Mobile submenu items */
.mobile-submenu-items,
.offcanvas-menu .submenu-items {
  display: flex;
  flex-direction: column;
  padding: 0 0 0 1rem;
  border-left: 2px solid rgba(0,0,0,0.08);
  margin-left: 1.2rem;
}

.mobile-subcategory-link {
  display: block;
  width: 100%;
  color: #444 !important;
  text-decoration: none !important;
  padding: 0.5rem 0.75rem !important;
  font-size: 0.82rem !important;
  border-radius: 6px;
  transition: background-color 0.15s ease, color 0.15s ease;
  border-bottom: none !important;
  background-color: transparent !important;
}

.mobile-subcategory-link:hover {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: #000 !important;
}

.subcategory-parent-link {
  font-weight: 600 !important;
  color: #222 !important;
}

.mobile-subcategory-children {
  display: flex !important;
  flex-direction: column !important;
  padding-left: 0.75rem !important;
  border-left: 1px solid rgba(0,0,0,0.07);
  margin-left: 0.5rem;
}

.mobile-grandchild-link {
  color: #666 !important;
  font-size: 0.78rem !important;
  text-decoration: none !important;
  padding: 0.35rem 0.6rem !important;
  border-radius: 5px;
  transition: color 0.15s ease, background-color 0.15s ease;
  border-bottom: none !important;
}

.mobile-grandchild-link:hover {
  color: #111 !important;
  background-color: rgba(0,0,0,0.04) !important;
}

.subcategory-with-children {
  display: flex;
  flex-direction: column;
  border-bottom: none !important;
}

/* Social links in footer */
.social-links-mobile {
  display: flex;
  gap: 0.75rem;
}

.social-link-mobile {
  color: #555 !important;
  text-decoration: none;
  font-size: 1.1rem;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(0,0,0,0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.social-link-mobile:hover {
  background-color: var(--primary-color) !important;
  color: #fff !important;
}

.offcanvas-footer small {
  color: rgba(0,0,0,0.35) !important;
}

/* Info Links Styles */
.info-links {
  gap: 1.25rem;
}

.info-link {
  color: var(--text-dark);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
}

.info-link:hover {
  color: var(--primary-color);
}

.info-link i {
  font-size: 0.9rem;
}


/* Skeleton Loaders for Category Menu */
.skeleton-item {
  display: flex;
  align-items: center;
}

.skeleton-link {
  display: flex;
  align-items: center;
  width: 120px;
  animation: pulse 1.5s infinite ease-in-out;
}

.skeleton-icon {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.1);
  margin-right: 8px;
}

.skeleton-text {
  height: 14px;
  width: 80px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.mobile-skeleton-menu {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 0;
}

.mobile-skeleton-item {
  padding: 8px 0;
}

.skeleton-button {
  height: 40px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  animation: pulse 1.5s infinite ease-in-out;
}

@keyframes pulse {
  0% {
    opacity: 0.6;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.6;
  }
}

/* Resaltar más el menú activo */
.has-dropdown {
  position: relative;
}

.has-dropdown::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: var(--primary-color);
  transition: width 0.3s ease;
}

.has-dropdown:hover::after,
.has-dropdown:focus-within::after {
  width: 100%;
}

/* Desktop Search Button */
.desktop-search-btn {
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.desktop-search-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.desktop-offcanvas-menu {
  position: fixed;
  top: 0;
  right: 0;
  width: 340px;
  height: 100vh;
  background-color: #fff;
  z-index: 1050;
  overflow-y: auto;
  transform: translateX(100%);
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
}

.desktop-offcanvas-menu.show {
  transform: translateX(0);
}

.desktop-offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  z-index: 1045;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.35s ease;
  pointer-events: none;
}

.desktop-offcanvas-backdrop.show {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.desktop-menu-item {
  margin-bottom: 2px;
}

.desktop-link {
  display: flex;
  align-items: center;
  padding: 0.75rem 0.9rem;
  color: #111 !important;
  text-decoration: none !important;
  font-weight: 500;
  font-size: 0.85rem;
  letter-spacing: 0.03em;
  border-radius: 8px;
  transition: background-color 0.2s ease, color 0.2s ease;
  width: 100%;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
}

.desktop-link:hover {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: #000 !important;
}

.desktop-skeleton-menu {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 8px 0;
}

.desktop-skeleton-item {
  padding: 4px 0;
}

/* Desktop accordion */
.desktop-offcanvas-menu .accordion-item {
  background: transparent;
  border: none !important;
  margin-bottom: 2px;
}

.desktop-offcanvas-menu .accordion-button {
  padding: 0.75rem 0.9rem;
  font-weight: 500;
  font-size: 0.85rem;
  letter-spacing: 0.03em;
  color: #111 !important;
  background-color: transparent !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  border: none !important;
  width: 100%;
  text-transform: none;
}

.desktop-offcanvas-menu .accordion-button:hover {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: #000 !important;
}

.desktop-offcanvas-menu .accordion-button:not(.collapsed) {
  color: var(--primary-color) !important;
  background-color: rgba(0, 0, 0, 0.04) !important;
  box-shadow: none !important;
}

.desktop-offcanvas-menu .accordion-button:focus {
  box-shadow: none;
  border-color: transparent;
}

.desktop-offcanvas-menu .accordion-button::after {
  filter: none;
  opacity: 0.5;
}

.desktop-offcanvas-menu .accordion-button:not(.collapsed)::after {
  opacity: 1;
  transform: rotate(-180deg);
}

.desktop-offcanvas-menu .accordion-body {
  background: transparent;
  padding: 0 0 0.25rem;
}

.desktop-offcanvas-menu .submenu-items {
  display: flex;
  flex-direction: column;
  padding: 0 0 0 0.75rem;
  border-left: 2px solid rgba(0,0,0,0.08);
  margin-left: 1.5rem;
}

.desktop-offcanvas-menu .submenu-link {
  display: block;
  padding: 0.5rem 0.75rem;
  color: #444 !important;
  text-decoration: none !important;
  font-size: 0.82rem;
  border-radius: 6px;
  transition: background-color 0.15s ease, color 0.15s ease;
  margin-bottom: 1px;
}

.desktop-offcanvas-menu .submenu-link:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #000 !important;
  padding-left: 1rem;
}

/* Estilos específicos para mobile */
@media (max-width: 991.98px) {
  /* already handled by the unified dark theme above */
}

/* Search suggestions (desktop) */
.navbar-search-inner {
  position: relative;
}

.navbar-search-suggestions {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18);
  border: 1px solid rgba(0, 0, 0, 0.08);
  z-index: 1200;
  overflow: hidden;
}

.navbar-suggest-list {
  display: flex;
  flex-direction: column;
}

.navbar-suggest-item {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.7rem 0.9rem;
  background: transparent;
  border: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease;
}

.navbar-suggest-item:hover {
  background: #f6f6f6;
}

.navbar-suggest-thumb {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  overflow: hidden;
  background: #f2f2f2;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navbar-suggest-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.navbar-suggest-thumb-placeholder {
  color: #b8b8b8;
}

.navbar-suggest-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}

.navbar-suggest-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.navbar-suggest-brand {
  font-size: 0.75rem;
  color: #808080;
}

.navbar-suggest-price {
  font-size: 0.85rem;
  font-weight: 700;
  color: #111111;
  white-space: nowrap;
  margin-left: 0.5rem;
}

.navbar-suggest-see-all {
  background: #111111;
  color: #ffffff;
  font-weight: 600;
  font-size: 0.82rem;
  padding: 0.65rem 0.9rem;
  border: none;
  cursor: pointer;
  text-align: center;
  transition: background 0.2s ease;
}

.navbar-suggest-see-all:hover {
  background: #2c2c2c;
}

.navbar-suggest-empty {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 1rem 1.1rem;
  color: #777;
  font-size: 0.85rem;
}

.navbar-suggest-loading {
  padding: 0.7rem 0.9rem;
}

.navbar-suggest-skeleton {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.4rem 0;
}

.navbar-suggest-skeleton-img {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: #f0f0f0;
  animation: navbar-skeleton 1.4s infinite;
}

.navbar-suggest-skeleton-lines {
  flex: 1;
}

.navbar-suggest-skeleton-line {
  height: 10px;
  background: #f0f0f0;
  border-radius: 6px;
  margin-bottom: 6px;
  animation: navbar-skeleton 1.4s infinite;
}

.navbar-suggest-skeleton-line.short {
  width: 45%;
}

@keyframes navbar-skeleton {
  0% { opacity: 0.5; }
  50% { opacity: 1; }
  100% { opacity: 0.5; }
}

/* Search suggestions (mobile) */
.mobile-search-suggestions {
  margin-top: 0.65rem;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.mobile-suggest-list {
  display: flex;
  flex-direction: column;
}

.mobile-suggest-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.7rem 0.9rem;
  background: transparent;
  border: none;
  text-align: left;
  width: 100%;
  cursor: pointer;
  transition: background 0.15s ease;
}

.mobile-suggest-item:hover {
  background: #f6f6f6;
}

.mobile-suggest-thumb {
  width: 46px;
  height: 46px;
  border-radius: 10px;
  overflow: hidden;
  background: #f2f2f2;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-suggest-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mobile-suggest-thumb-placeholder {
  color: #b8b8b8;
}

.mobile-suggest-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}

.mobile-suggest-name {
  font-size: 0.88rem;
  font-weight: 600;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile-suggest-brand {
  font-size: 0.72rem;
  color: #808080;
}

.mobile-suggest-price {
  font-size: 0.82rem;
  font-weight: 700;
  color: #111111;
  white-space: nowrap;
  margin-left: 0.4rem;
}

.mobile-suggest-see-all {
  background: #111111;
  color: #ffffff;
  font-weight: 600;
  font-size: 0.8rem;
  padding: 0.6rem 0.9rem;
  border: none;
  cursor: pointer;
  text-align: center;
}

.mobile-suggest-empty {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.9rem 1rem;
  color: #777;
  font-size: 0.82rem;
}

.mobile-suggest-loading {
  padding: 0.7rem 0.9rem;
}

.mobile-suggest-skeleton {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  padding: 0.35rem 0;
}

.mobile-suggest-skeleton-img {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #f0f0f0;
  animation: navbar-skeleton 1.4s infinite;
}

.mobile-suggest-skeleton-lines {
  flex: 1;
}

.mobile-suggest-skeleton-line {
  height: 10px;
  background: #f0f0f0;
  border-radius: 6px;
  margin-bottom: 6px;
  animation: navbar-skeleton 1.4s infinite;
}

.mobile-suggest-skeleton-line.short {
  width: 45%;
}
</style>
